import { render } from "./logo-explorer.svg?vue&type=template&id=1408cc68?inline"
const script = {}
script.render = render

export default script